import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { UserService } from '@app/services';
import { UserSettingsAutoinvestContractComponent } from '../user-settings-autoinvest-contract/user-settings-autoinvest-contract.component';
import { ToastrService } from 'ngx-toastr';

@Component({
   selector: 'mnf-user-settings-autoinvest-activate',
   templateUrl: './user-settings-autoinvest-activate.component.html',
   styleUrls: ['./user-settings-autoinvest-activate.component.scss']
})
export class UserSettingsAutoinvestActivateComponent {
   
   currentParagraph: number | null = 1;
   selectedValue: string | null = null;

   autoInvestForm = new FormGroup({
      selectedOption: new FormControl(null, Validators.required)
   });

   constructor(
      private dialogRef: MatDialogRef<any>,
      private dialog: MatDialog,
      private userServ: UserService
   ) { }

   showParagraph(paragraphNumber: number): void {
      this.currentParagraph = paragraphNumber;
   }

   updateAutoinvest() {
      if (this.autoInvestForm.valid) {
         this.openAutoInvestContract();
      }
   }

   openAutoInvestContract() {
      forkJoin({
         user: this.userServ.getUserInf(),
         userB: this.userServ.getUserInfoAdditional()
      }).subscribe(({ user, userB }) => {
         
         const userInfo = { ...user, ...userB };

         const m = this.dialog.open(UserSettingsAutoinvestContractComponent, {
            maxWidth: '950px',
            width: '95%',
            panelClass: 'mnf-modal-container',
            autoFocus: false,
            disableClose: false,
            height: '90vh',
         });

         m.componentInstance.user = userInfo;
         m.componentInstance.autoinvestData = this.autoInvestForm.value;

         this.dialogRef.close();

         m.beforeClosed().subscribe(accepted => {
            if (accepted) this.dialogRef.close(accepted);
         });
      });
   }

   onOptionChange(selectedValue: string) {
      this.selectedValue = selectedValue;
   }

   close() {
      this.dialogRef.close();
   }
}
